import { useLingui } from "@lingui/react/macro";
import z from "zod";

export function useLoginFormSchema() {
  const { t } = useLingui();

  return z.object({
    username: z.email({
      error: t`Vänligen ange din e-postadress`,
    }),
    password: z.string({
      error: t`Vänligen ange ett lösenord`,
    }),
  });
}
